import { useState, useEffect } from 'react';
import { decorationRepository } from '../../../domain/decorationsRepository';


export const useDecorations = (typeCode, page) => {
    const [decorationsResult, setDecorationsResult] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [isNextPageLoading, setIsNextPageLoading] = useState(false);

    useEffect(() => {
        console.log(`trigger useDecorations typeCode: ${typeCode}`)
        console.log(`trigger useDecorations page: ${page}`)
        setIsNextPageLoading(page !== 0)
        console.log(`trigger useDecorations page !== 0: ${page !== 0}`)
        decorationRepository.getDecorations(typeCode, page)
        .then((result) => {
            setDecorationsResult(result)
            setIsLoading(false)
            setIsNextPageLoading(false)
        })
        .catch((err) => {
            console.error("Failed to fetch decoration types:", err)
            setIsLoading(false)
            setIsNextPageLoading(false)
        });
    }, [typeCode, page]);

    return { ...decorationsResult, isLoading, isNextPageLoading };
};